module.exports = __webpack_public_path__ + "img/car_00030.98318654.jpg";